import { render, staticRenderFns } from "./CorporateMenuTypes.vue?vue&type=template&id=4f6abebb"
import script from "./CorporateMenuTypes.vue?vue&type=script&lang=js"
export * from "./CorporateMenuTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports